import close from '../../../pages/tennis-hub/assets/close.svg';

// jquery
$(document).ready(() => {
  const loadIframe = (el) => {
    const youtubeId = $(el).data('youtube-id');
    if (youtubeId) {
      const url = `https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1`;
      $(el).attr('src', url);
    }
  };

  const unloadIframe = (el) => {
    $(el).attr('src', null);
  };

  $('.r7-teaser__container').modal('.r7-teaser__modal-content', {
    className: 'reno7',
    closeText: close,
    openCb: () => {
      loadIframe('#oc-modal-container .r7-teaser__modal-video');
    },
    beforeCloseCb: () => {
      unloadIframe('#oc-modal-container .r7-teaser__modal-video');
    },
  });
});
